module.exports = __webpack_public_path__ + "img/prod-oven.ea85da63.jpg";